/** Client page types that opt in to Swagmagic store breadcrumbs via setPageState. */
export const BREADCRUMB_LISTING = "listing";
export const BREADCRUMB_BRAND = "brand";
export const BREADCRUMB_SEARCH = "search";
export const BREADCRUMB_COLLECTION = "collection";
export const BREADCRUMB_CATALOG = "catalog";
export const BREADCRUMB_CATCH_ALL = "catchAll";
